<template>
    <div>
        <h5>Últimas publicaciones</h5>
        <ul class="blog_posts">
            <li v-for="post in posts" :key="`post_${post.id}`">
                <a>{{post.title}}</a>
                <small style="text-transform: uppercase;">{{formatDate(post.createdAt)}}</small>
            </li>
        </ul>
    </div>
</template>

<script>
    import moment from 'moment';
    import axiosInstance from '../../HttpRequest';

    export default {
        data() {
          return {
            $language: '',
            posts: [],
          };
        },
        created : function(){
            var self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
            });
            axiosInstance.get(`/post?populate=author&sort=id DESC&limit=3&where={"lang":"${self.$language}"}`).then((resp) => {
              self.posts = resp.data;
            });
        },
        beforeDestroy : function(){
            this.unsubscribe();
        },
        methods: {
          formatDate(date) {
            return moment(date).format('MMM DD, YYYY');
          },
        },
    }
</script>


// WEBPACK FOOTER //
// News.vue?4b2e7eb6